// extracted by mini-css-extract-plugin
export var infoText = "styles-module--info-text--c6b93";